import React from "react";

import { AssetPositionEnum } from "../../models/IContentBlock";
import ITimelineItem from "../../models/ITimelineItem";
import ContentRichText from "../contentRichText";
import { Col, Grid } from "../grid";
import {
  TimelineBottomSection,
  TimelineContainerStyle,
  TimelineHeaderStyle,
  TimelineParagraphAssetContainerStyle,
  TimelineYearStyle,
  TimelineParagraphsContainerStyle,
} from "./TimelineList.style";
import IRichText from "../../models/IRichText";
import SectionWrapper from "../sectionWrapper";
import { EmptyTabletCol } from "../commons/Commons.style";
import GImage, { hasImage } from "../gImage/GImage";

interface ITimelineListProps {
  timeline: ITimelineItem[];
  timelineName: IRichText;
}

const TimelineList = ({ timeline, timelineName }: ITimelineListProps) => {
  return (
    <SectionWrapper>
      <Grid cols={12} columnGap={16} rowGap={0}>
        <EmptyTabletCol />
        <Col xxl={12} md={10} sm={12}>
          <TimelineHeaderStyle>
            <ContentRichText content={timelineName} />
          </TimelineHeaderStyle>
        </Col>
        <EmptyTabletCol />
      </Grid>
      <div>
        {(timeline || []).map(
          ({
            id,
            itemDate,
            itemDescription,
            image,
            imageAlt,
            publicUrl,
            imagePosition,
          }) => {
            return (
              <TimelineContainerStyle key={id}>
                <Grid cols={12} columnGap={16} rowGap={0}>
                  <EmptyTabletCol />
                  <Col xxl={4} md={2} sm={4}>
                    <TimelineYearStyle>{itemDate}</TimelineYearStyle>
                  </Col>
                  <Col xxl={8} md={7} sm={8}>
                    <TimelineParagraphsContainerStyle>
                      <ContentRichText content={itemDescription} />
                    </TimelineParagraphsContainerStyle>
                  </Col>
                  <EmptyTabletCol />
                </Grid>
                {hasImage({ image, publicUrl }) && (
                  <Grid cols={12} columnGap={16} rowGap={0}>
                    <Col
                      xxl={
                        imagePosition === AssetPositionEnum.FULLWIDTH ? 0 : 4
                      }
                      md={1}
                      sm={0}
                      xs={0}
                    />
                    <Col
                      xxl={
                        imagePosition === AssetPositionEnum.FULLWIDTH ? 12 : 8
                      }
                      md={10}
                      sm={12}
                    >
                      <TimelineParagraphAssetContainerStyle>
                        <GImage
                          imageInfo={{
                            image,
                            imageAlt,
                            publicUrl,
                          }}
                        />
                      </TimelineParagraphAssetContainerStyle>
                    </Col>
                  </Grid>
                )}
                <Grid cols={12} columnGap={16} rowGap={0}>
                  <EmptyTabletCol />
                  <Col xxl={12} md={10} sm={12}>
                    <TimelineBottomSection />
                  </Col>
                </Grid>
              </TimelineContainerStyle>
            );
          }
        )}
      </div>
    </SectionWrapper>
  );
};

export default TimelineList;
